import { useTranslation } from "react-i18next";
import type { AgentType } from "../types";
import { getAgentTheme, WelcomeAgentIcon } from "../constants/agents";
import { BetaTag } from "./beta-tag";

type AssistantIdentityProps = {
  agentType?: AgentType | null;
};

/** Identifica o agente responsável por uma interação individual do chat. */
export function AssistantIdentity({ agentType }: AssistantIdentityProps) {
  const [translate] = useTranslation(["core"]);
  const agentTheme = agentType ? getAgentTheme(agentType) : null;

  return (
    <div
      className="mb-2 flex items-center gap-2"
      data-testid="assistant-identity"
    >
      <img
        src={agentTheme?.iconSrc ?? WelcomeAgentIcon}
        alt=""
        aria-hidden
        className="size-5 object-contain"
      />
      <span className="text-sm font-semibold text-darkgray-700">
        {agentTheme ? (
          <>
            {translate("chatbot-hub-title-prefix")}{" "}
            <i className="font-serif font-semibold italic">
              {translate(agentTheme.nameKey) as string}
            </i>
          </>
        ) : (
          translate("chatbot-agent-facilities-name")
        )}
      </span>
      <BetaTag />
    </div>
  );
}
